import { useState, useRef } from "react";
import { Button, Checkbox, Modal, Form, Input, Popover } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { ReactComponent as HelpIcon } from "../../../assets/images/Help.svg";
import "./CreateHerd.scss";
import PopoverTitle from "../../common/PopoverTitle";
import clsx from "clsx";

function CreateHerd(props) {
  const {
    onBackButtonClick,
    createHerdModal,
    setCurrentStep,
    currentStepDetails,
    herdStep5Popover,
    setHerdMarkerDetails,
  } = props;
  const [collarsList] = useState([
    "00005c185bfff806",
    "00005c185bfff83b",
    "00005c185bfffce2",
    "00005c185bfffce3",
    "00005c185bfffce4",
    "00005c185bfffce5",
    "00005c185bfffce6",
    "00005c185bfffd04",
    "00005c185bfffd07",
    "00005c185bfffd08",
  ]);
  const [herdName, setHerdName] = useState("");

  const createHerdModalTitle = (
    <div className="header">
      <div className="title">Create Herd</div>
      <Button
        className="canel-button"
        style={{ marginLeft: "auto" }}
        type="link"
      >
        Cancel
      </Button>
      <Button
        className="save-button"
        onClick={() => {
          onBackButtonClick();
          setCurrentStep((step) => step + 1);
          setHerdMarkerDetails((value) => ({
            ...value,
            herdName: herdName,
          }));
        }}
      >
        Save
      </Button>
      <Button type="text" icon={<HelpIcon className="help-icon" />} />
    </div>
  );

  const contentOfcreateHerdModal = (
    <div>
      <p>
        Give this new herd a name and click <strong>SAVE.</strong>
      </p>
    </div>
  );

  const contentOfSelectCollarsOnMap = (
    <div>
      <p>
        At this point, you could choose each animal by its unique collar ID from
        the long list. But let’s make things simple by clicking{" "}
        <strong>SELECT COLLARS ON MAP.</strong>
      </p>
    </div>
  );

  return (
    <div>
      <Button
        block
        className="back-button"
        onClick={() => onBackButtonClick()}
        icon={<ArrowLeftOutlined />}
      >
        BACK
      </Button>
      <div className="create-herd">
        <div className="header">
          <label className="title">Create Herd</label>
          <Button
            type="text"
            style={{ marginLeft: "auto" }}
            icon={<HelpIcon className="help-icon" />}
          />
        </div>
        <div className="create-herd-body">
          <Button
            block
            onClick={() => {
              setCurrentStep((step) => step + 1);
            }}
            id="create-herd-button"
            className={clsx("sub-item", {
              "overlay-element-active":
                currentStepDetails.overlayElementsId?.includes(
                  "create-herd-button"
                ),
            })}
          >
            Create Herd
          </Button>
          <Popover
            title={PopoverTitle}
            content={contentOfSelectCollarsOnMap}
            placement="leftTop"
            trigger="hover"
            visible={herdStep5Popover}
          >
            <Button
              block
              onClick={() => {
                setCurrentStep((step) => step + 1);
              }}
              id="select-collars-on-map-button"
              className={clsx("sub-item", {
                "overlay-element-active":
                  currentStepDetails.overlayElementsId?.includes(
                    "select-collars-on-map-button"
                  ),
              })}
            >
              Select Collars on Map
            </Button>
          </Popover>
          <Button block className="sub-item">
            Select All
          </Button>
          <div className="collars-list">
            {collarsList.map((collar) => (
              <div className="collar-item" key={collar}>
                <Checkbox>
                  <span className="collar-name"></span>
                  <span className="collar-Id">{collar}</span>
                </Checkbox>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Modal
        visible={createHerdModal}
        title={createHerdModalTitle}
        footer={null}
        className="create-herd-modal"
        closable={false}
        width={600}
        style={{ height: "500px" }}
        centered
        destroyOnClose={true}
      >
        <div className="body">
          <div className="modal-content">
            <Form layout="vertical" className="create-herd-form">
              <Popover
                title={PopoverTitle}
                content={contentOfcreateHerdModal}
                placement="leftTop"
                trigger="hover"
                visible={createHerdModal}
              >
                <Form.Item label="Herd Name">
                  <Input
                    value={herdName}
                    onChange={(e) => setHerdName(e.target.value)}
                  />
                </Form.Item>
              </Popover>
            </Form>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default CreateHerd;
